/**
 * Detect stack-harmony channels by their name pattern (e.g. "Chorus · MyVoice (2/3)"),
 * parse the voice index + total, and recompute panning at a user-controlled
 * "width" (0 = mono center, 1 = full -0.5..+0.5 spread).
 *
 * Returns the number of channels re-panned.
 */
export function applyStackWidth(engine, width) {
  if (!engine?.channels) return 0;
  // Group stacked channels by their (voiceIdx, total) pair so we can apply
  // consistent panning regardless of section.
  let count = 0;
  for (let i = 0; i < engine.channels.length; i++) {
    const c = engine.channels[i];
    if (!c?.buffer || !c.name) continue;
    const match = c.name.match(/\((\d+)\/(\d+)\)/);
    if (!match) continue;
    const voiceIdx = parseInt(match[1], 10) - 1;
    const total = parseInt(match[2], 10);
    if (total < 2) continue;
    const basePan = -0.5 + (voiceIdx * (1)) / (total - 1);
    engine.setChannelPan(i, basePan * Math.max(0, Math.min(1, width)));
    count++;
  }
  return count;
}
